import React, { useState } from "react"
import CustomImage from "@/main/customImage"
import { useSpring, animated } from "react-spring"
import { Waypoint } from "react-waypoint"

import { Card } from "react-bootstrap"

function CharacteristicsCard(props) {
    const [inView, setInView] = useState(false)

    const fadeLeft = useSpring({
        delay: props.delay,
        to: {
            opacity: inView ? 1 : 0,
            marginRight: inView ? 0 : 50,
        },
    })
    return (
        <Waypoint onEnter={() => setInView(true)}>
            <animated.div className="h-100" style={fadeLeft}>
                <Card
                    className="py-sm-4 px-sm-3 characteristics-carousel h-100"
                    style={{ height: "100%" }}
                >
                    <div className="icon-div">
                        <CustomImage
                            src={`https://webb-jenkins-static-164679926.imgix.net/icons/${props.icon}`}
                            alt={props.alt}
                            layout="fill"
                            objectPosition="center"
                        />
                    </div>
                    <Card.Title>
                        <h3 className="h5 mt-3 text-center">{props.title}</h3>
                    </Card.Title>
                    <Card.Text className="text-center">
                        <span>{props.description}</span>
                    </Card.Text>
                </Card>
            </animated.div>
        </Waypoint>
    )
}

export default CharacteristicsCard
